import ProductAvailability from '@dustin-web/product-components/src/product-availability'
import type { ProductPageType } from '@productsite-beta/src/components/product-page-v2'

import './product-availability.scss'

type Props = {
  availability: ProductPageType['availability']
  isBid: boolean
  compactStatus?: boolean
  listForm?: boolean
}

export const ProductAvailabilityContainer = ({
  availability,
  isBid,
  compactStatus,
  listForm,
}: Props) => {
  if (availability?.IsNotifyEligible) {
    return null
  }

  return (
    <ProductAvailability
      listForm={listForm}
      compactStatus={compactStatus}
      availability={availability}
      isBid={isBid}
      showIsBidInfoText={isBid}
      iconClassName="i-20"
      className="gap-8 availability-text"
      availabilityTextClassName={false}
      deliveryContainerClassName="d-flex gap-8 availability-text"
      containerClassNames="gap-8 product-availability"
      infoTextClassName="u-pt-8"
    />
  )
}

export default ProductAvailabilityContainer
